module.exports = __webpack_public_path__ + "img/bar-horizontal-icon-white.ac085a43.svg";